import { SvgIcon } from "@mui/material";

// Eye Icon
export function UnSuccessIcon(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
      }}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21936_263929)">
        <path
          d="M10.8328 11.793L4.82031 17.8054M4.82112 11.793L10.8337 17.8054"
          stroke={props.color || "#000000"}
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9979 12.1604H20.1794M4.82031 6.70312H20.1795M14.9979 17.8017H20.1794"
          stroke={props.color || "#000000"}
          strokeWidth="1.44"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_21936_263929">
          <rect width="24" height="24" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
